import { Component, Input } from '@angular/core';

@Component({
  selector: 'st-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  @Input() public text: string;
}
